module.exports = {"publicPath":"/dadosabertos/","apiUrl":"https://egov.santos.sp.gov.br/dadosabertos/backend/api/","imgUrl":"https://egov.santos.sp.gov.br/dadosabertos/upload/"}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = ufme
// module chunks = 15